// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__UITNR","return-link":"navigation_return-link__cViTF"};